const shadows = {
  CARD_SHADOW: '5px 5px 4px 0px #00000026',
  NAV_RAIL_SHADOW: '4px 4px 4px 0px #00000026',
}

export default shadows
